module.exports = __webpack_public_path__ + "static/media/coffin.1d35ca2e.svg";